export function formatMoney(
  num?: number | string,
  defaultValue: string = '--',
  options?: Intl.NumberFormatOptions
) {
  const money = Number(num);
  if (isNaN(money)) return defaultValue;
  return new Intl.NumberFormat(undefined, options).format(money);
}
